jQuery(document).ready(function(){
	if(jQuery('body').hasClass('page-template-page-contactus'))
	{
		
		var activeItem = localStorage.getItem('activejob');
		console.log(activeItem);
		if(activeItem != null)
		{
			var activeJob = jQuery('.job[data-tag="'+activeItem+'"');
			jQuery('.job.active').removeClass('active');
			activeJob.addClass('active');
				var formsection = jQuery('.form_section', activeJob);
				var title = jQuery('.title', activeJob);
				var title = title.data('name');
				jQuery('#gform_wrapper_3').detach().appendTo(formsection);
				jQuery('#input_3_13').val(title);
				jQuery('html, body').animate({   scrollTop: jQuery(".form_section").offset().top }, 1000);
				
		}
		
		jQuery('.job .title').click(function(){		
			localStorage.setItem('activejob', jQuery(this).parent('.job').data('tag'));
			if(jQuery(this).parent('.job').hasClass('active') == false)
			{
				jQuery('.job.active').removeClass('active');
				jQuery(this).parent('.job').addClass('active');
				var formsection = jQuery('.form_section', jQuery(this).parent('.job'));
				var title = jQuery('.title', jQuery(this).parent('.job'));
				var title = title.data('name');
				
				jQuery('#gform_wrapper_3').detach().appendTo(formsection);
				jQuery('#input_3_13').val(title);
			}
			else
			{
				
				jQuery('.job.active').removeClass('active');
			}
			
		});
	}
});